module.exports = __webpack_public_path__ + "static/media/wuzhixiong.f80677d8.png";